module.exports = __webpack_public_path__ + "static/media/logo.502b897e.webp";